import EnvelopeIcon from '../../images/icons/envelope.svg?react';
import { isAndroidChrome } from '../../utils/is-android-chrome';
import { getOwn } from '../../utils/get-own';
import { t } from '../../utils/i18n';

/**
 * @typedef {'gmail' | 'yahoo' | 'outlook' | 'proton' | 'icloud' | 'hey' | 'aol' | 'mailru' | 'feedbin' | 'dev-mailpit'} Provider
 */

const gmailIcon = (
  <svg
    height="24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 49.4 512 399.4200000000001"
  >
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <path
          d="M34.91 448.818h81.454V251L0 163.727V413.91c0 19.287 15.622 34.91 34.91 34.91z"
          fill="#4285f4"
        />
        <path
          d="M395.636 448.818h81.455c19.287 0 34.909-15.622 34.909-34.909V163.727L395.636 251z"
          fill="#34a853"
        />
        <path
          d="M395.636 99.727V251L512 163.727v-46.545c0-43.142-49.25-67.782-83.782-41.891z"
          fill="#fbbc04"
        />
      </g>
      <path d="M116.364 251V99.727L256 204.455 395.636 99.727V251L256 355.727z" fill="#ea4335" />
      <path
        d="M0 117.182v46.545L116.364 251V99.727L83.782 75.291C49.25 49.4 0 74.04 0 117.18z"
        fill="#c5221f"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

const outlookIcon = (
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    height="2500"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 6876 6994"
    width="2457"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 779L4033 0l-14 6994L0 6160zm1430 3632c-305-357-390-918-244-1384 203-648 718-867 1149-717 246 86 465 293 582 610 56 152 86 326 88 503 4 318-106 692-324 953-335 400-903 441-1250 35zm314-339c-150-223-191-573-120-864 99-404 352-541 563-447 121 54 228 183 285 381 27 95 42 203 43 314 2 198-52 432-159 595-164 250-442 275-612 22zm2552-2598h2341c131 0 238 107 238 238v86L5035 3039c-24 16-83 62-132 93-72 47-77 38-153-5-117-65-319-203-455-297V1474zm2580 875v2504c0 200-164 365-365 365H4296V3366c133 88 310 204 419 271 88 54 104 79 202 22 45-26 89-60 119-80l1840-1229z"
      fill="#0072c6"
    />
  </svg>
);

const yahooIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 3386.34 3010.5"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <path
      d="M0 732.88h645.84l376.07 962.1 380.96-962.1h628.76l-946.8 2277.62H451.98l259.19-603.53L.02 732.88zm2763.84 768.75h-704.26L2684.65 0l701.69.03-622.5 1501.6zm-519.78 143.72c216.09 0 391.25 175.17 391.25 391.22 0 216.06-175.16 391.23-391.25 391.23-216.06 0-391.19-175.17-391.19-391.23 0-216.05 175.16-391.22 391.19-391.22z"
      fill="#5f01d1"
      fillRule="nonzero"
    />
  </svg>
);

const protonIcon = (
  <svg
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
  >
    <path
      d="M22.86 13.464l.002.002-10.005 11.105L0 10.419V4.315a.827.827 0 011.356-.637l14.265 11.846a3.722 3.722 0 004.758 0l2.481-2.06z"
      fill="url(#prefix___Linear1)"
      transform="matrix(13.8889 0 0 13.8889 6 6)"
    />
    <path
      d="M28.286 8.958l-5.426 4.506.002.002-7.184 6.345a3.31 3.31 0 01-4.308.065L0 10.42v18.142a3.724 3.724 0 003.724 3.724h24.562l2.571-11.664-2.571-11.664z"
      fill="url(#prefix___Radial2)"
      fillRule="nonzero"
      transform="matrix(13.8889 0 0 13.8889 6 6)"
    />
    <path
      d="M28.286 8.963v23.323h3.99A3.724 3.724 0 0036 28.562V4.315a.827.827 0 00-1.356-.637l-6.358 5.285z"
      fill="url(#prefix___Linear3)"
      transform="matrix(13.8889 0 0 13.8889 6 6)"
    />
    <defs>
      <linearGradient
        id="prefix___Linear1"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="scale(-43.6455) rotate(73.941 .222 -.49)"
      >
        <stop offset="0" stopColor="#e3d9ff" />
        <stop offset="1" stopColor="#7341ff" />
      </linearGradient>
      <linearGradient
        id="prefix___Linear3"
        x1="0"
        y1="0"
        x2="1"
        y2="0"
        gradientUnits="userSpaceOnUse"
        gradientTransform="scale(-66.0342) rotate(65.129 .243 -.95)"
      >
        <stop offset="0" stopColor="#e3d9ff" />
        <stop offset=".27" stopColor="#e3d9ff" />
        <stop offset="1" stopColor="#7341ff" />
      </linearGradient>
      <radialGradient
        id="prefix___Radial2"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(35.9848 0 0 33.9185 30.723 11.814)"
      >
        <stop offset="0" stopColor="#6d4aff" />
        <stop offset=".56" stopColor="#6d4aff" />
        <stop offset=".99" stopColor="#aa8eff" />
        <stop offset="1" stopColor="#aa8eff" />
      </radialGradient>
    </defs>
  </svg>
);

const icloudIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2500"
    height="2432"
    viewBox="85.04 232.402 412.912 401.703"
  >
    <path
      d="M391.631 424.861l-4.477-1.119v-4.477c0-40.281-32.449-72.73-71.611-72.73-29.094 0-55.947 17.904-67.138 44.758l-3.355 7.834-5.595-5.596c-5.597-5.594-13.429-8.951-21.262-8.951a30.086 30.086 0 0 0-30.211 30.211l1.118 6.715-4.476 1.117c-21.26 6.715-35.807 25.736-35.807 46.996 0 26.854 22.38 49.234 49.234 49.234h185.745c25.734 0 48.113-21.262 48.113-48.115-1.114-22.379-16.78-41.401-40.278-45.877z"
      fill="#333"
    />
    <path
      d="M394.989 232.402H189.102c-58.185 0-104.062 46.996-104.062 104.062v193.578c0 58.186 46.995 104.062 104.062 104.062H393.87c58.187 0 104.062-46.996 104.062-104.062V337.583c1.118-58.185-45.877-105.181-102.943-105.181zm-11.19 298.76H198.054c-33.568 0-60.424-26.855-60.424-60.424 0-25.734 15.666-46.996 39.164-55.947 1.118-22.379 19.021-40.281 41.4-40.281 7.833 0 15.666 2.238 22.379 6.713 14.547-27.973 42.521-44.758 73.852-44.758 44.758 0 81.684 35.809 82.802 79.447 25.736 6.713 44.759 30.211 44.759 57.066-.001 31.328-25.737 58.184-58.187 58.184z"
      fill="#333"
    />
    <path
      d="M398.345 414.791c-2.237-44.758-38.044-79.445-82.802-79.445-31.33 0-60.424 17.904-73.852 44.76-6.714-4.477-14.546-6.715-22.379-6.715-22.379 0-40.282 17.902-41.401 40.281-23.498 8.951-39.163 31.33-39.163 55.947 0 33.568 26.855 60.424 60.424 60.424h185.746c32.448 0 59.304-26.854 59.304-59.305-2.237-25.737-20.14-49.233-45.877-55.947zm-14.546 105.181H198.054c-26.854 0-49.233-22.379-49.233-49.232 0-22.379 14.546-40.283 35.806-46.996l4.476-1.119-1.118-6.713c0-16.785 13.427-30.213 30.211-30.213 7.833 0 15.666 3.357 21.262 8.953l5.595 5.594 3.355-7.832c11.189-26.855 36.925-44.758 67.138-44.758 40.281 0 71.611 32.449 71.611 72.73v4.477l4.477 1.119c23.498 3.355 39.164 23.498 39.164 46.996-.003 25.734-21.264 46.994-46.999 46.994z"
      fill="#e4e4e4"
    />
  </svg>
);

const defaultEmailIcon = <EnvelopeIcon className="gh-portal-inbox-link-icon" />;
const feedbinIcon = (
  <svg
    className="gh-portal-inbox-link-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 183.436 170.826"
  >
    <path
      d="M183.432,89.959c-0.048-3.063-0.497-6.082-1.334-8.975c-0.901-3.114-2.23-6.177-3.96-9.13 c1.092-6.758,0.659-13.689-1.293-20.634c-1.09-3.878-2.657-7.671-4.658-11.274c-1.858-3.346-4.149-6.63-6.808-9.762 c-2.993-3.525-6.414-6.812-10.168-9.771c-3.486-2.747-7.374-5.301-11.558-7.591c-7.209-3.946-14.975-7.019-23.083-9.133 c-7.625-1.988-15.79-3.189-24.268-3.569C94.507,0.041,92.693,0,90.909,0c-5.665,0-11.351,0.411-16.901,1.223 c-4.65,0.68-9.204,1.621-13.534,2.798c-4.53,1.231-8.963,2.759-13.178,4.543c-4.808,2.035-9.322,4.378-13.417,6.965 c-4.412,2.787-8.502,5.96-12.158,9.43c-2.899,2.752-5.481,5.651-7.674,8.618c-2.396,3.241-4.419,6.682-6.011,10.228 C3.237,54.494,2.171,65.255,4.855,75.84c-1.278,2-2.296,3.965-3.088,5.95c-0.592,1.485-1.401,3.773-1.596,6.482 c-0.317,4.391-0.128,7.032,0.042,8.637c0.333,3.151,1.017,5.92,2.092,8.466c0.876,2.076,2.015,3.983,3.401,5.698 c-0.004,5.271,0.282,9.628,0.896,13.697c1.658,10.979,6.794,20.282,15.266,27.651c4.024,3.5,8.628,6.417,14.075,8.919 c5.796,2.662,12.181,4.704,19.522,6.243c8.669,1.818,17.734,2.833,27.715,3.104c3.439,0.093,6.638,0.139,9.78,0.139 c9.007,0,17.141-0.382,24.867-1.166c6.781-0.689,12.409-1.619,17.71-2.928c6.693-1.652,12.44-3.876,17.568-6.798 c8.917-5.081,15.441-12.349,19.391-21.602c2.111-4.945,3.553-10.188,4.41-16.029c0.666-4.539,0.908-9.172,0.735-14.094 c0.853-0.902,1.612-1.88,2.272-2.926c1.256-1.991,2.15-4.232,2.657-6.659C183.186,95.673,183.476,92.758,183.432,89.959z"
      fill="#fff"
    />
    <path
      d="M173.954,83.388c-0.899-3.108-2.287-5.99-4.047-8.692c-0.474-0.728-0.658-1.389-0.47-2.279 c1.343-6.341,0.995-12.63-0.755-18.853c-1.889-6.72-5.305-12.61-9.8-17.904c-5.448-6.416-12.031-11.427-19.381-15.45 C125.884,12.754,111.195,9.212,95.77,8.519c-6.929-0.311-13.839,0.017-20.718,1.023c-8.509,1.244-16.751,3.418-24.674,6.771 c-8.536,3.613-16.346,8.365-23.092,14.769c-4.932,4.682-9.028,9.992-11.824,16.221c-4.232,9.425-5.189,19.102-2.002,29.042 c0.265,0.827,0.092,1.412-0.395,2.077c-1.489,2.036-2.795,4.184-3.733,6.539c-0.515,1.291-0.927,2.607-1.027,4.003 c-0.172,2.389-0.234,4.781,0.018,7.165c0.455,4.306,1.817,8.219,5.054,11.288c0.181,0.171,0.324,0.381,0.485,0.573 c0,1.019,0.002,2.025,0,3.03c-0.008,4.218,0.171,8.417,0.803,12.603c1.374,9.101,5.583,16.602,12.502,22.62 c3.637,3.163,7.719,5.63,12.088,7.636c5.688,2.612,11.646,4.38,17.759,5.662c8.651,1.814,17.416,2.691,26.234,2.93 c11.207,0.304,22.41,0.147,33.582-0.988c5.579-0.567,11.112-1.384,16.558-2.728c5.396-1.332,10.595-3.186,15.444-5.95 c7.244-4.128,12.584-9.967,15.861-17.644c1.912-4.478,3.125-9.158,3.831-13.971c0.724-4.938,0.85-9.899,0.54-14.875 c-0.035-0.559-0.005-1.122-0.005-1.68c0.277-0.229,0.509-0.441,0.761-0.624c2.407-1.746,3.853-4.108,4.456-6.994 C175.228,92.451,175.26,87.905,173.954,83.388z M25.87,54.851c1.457-4.008,3.659-7.581,6.39-10.84 c3.801-4.534,8.35-8.186,13.371-11.271c6.978-4.287,14.527-7.192,22.458-9.141c9.052-2.223,18.25-3.033,27.545-2.583 c11.875,0.575,23.304,3.097,34.088,8.223c3.31,1.573,6.398,3.515,9.185,5.907c2.226,1.91,4.011,4.165,5.223,6.852 c1.557,3.45,1.801,7.067,1.137,10.724c-1.438,7.927-5.544,14.206-12.025,18.963c-3.062,2.247-6.396,4.006-9.876,5.495 c-1.966,0.841-3.965,1.606-5.939,2.43c-0.695,0.29-1.378,0.621-2.033,0.992c-0.374,0.212-0.722,0.507-1.007,0.831 c-0.41,0.466-0.342,1.172,0.2,1.477c0.59,0.332,1.246,0.592,1.906,0.742c2.236,0.508,4.515,0.413,6.773,0.244 c6.232-0.464,12.355-1.564,18.35-3.342c4.801-1.424,9.319-3.445,13.369-6.433c0.198-0.146,0.428-0.252,0.649-0.365 c0.036-0.018,0.103,0.026,0.284,0.079c-0.133,0.339-0.239,0.679-0.393,0.995c-1.517,3.097-3.65,5.717-6.226,7.99 c-3.044,2.685-6.469,4.784-10.111,6.547c-5.639,2.73-11.577,4.576-17.678,5.911c-6.961,1.522-14.013,2.365-21.128,2.782 c-7.055,0.413-14.101,0.37-21.142-0.129c-9.633-0.683-19.127-2.177-28.327-5.23c-4.191-1.391-8.239-3.11-12.056-5.342 c-2.673-1.563-5.169-3.365-7.393-5.528c-3.469-3.373-5.944-7.326-6.877-12.122C23.6,64.645,24.112,59.687,25.87,54.851z M157.755,121.076c-0.765,3.911-2.589,7.332-5.152,10.365c-2.382,2.819-5.246,5.059-8.41,6.934c-4.693,2.78-9.76,4.638-15.008,6.032 c-5.789,1.537-11.68,2.494-17.637,3.108c-7.902,0.814-15.822,1.131-23.76,1.008c-6.677-0.103-13.335-0.525-19.946-1.496 c-6.928-1.017-13.722-2.574-20.219-5.257c-4.268-1.763-8.291-3.954-11.869-6.9c-4.679-3.852-8.141-8.547-9.866-14.42 c-0.66-2.245-1.048-4.533-1.006-6.881c0.006-0.362,0.071-0.724,0.115-1.144c0.59,0,1.084-0.05,1.565,0.009 c2.26,0.276,4.527,0.297,6.789,0.133c5.883-0.428,11.207,1.103,16.057,4.416c2.92,1.995,5.599,4.282,8.158,6.709 c2.009,1.906,3.968,3.864,5.939,5.81c2.301,2.271,4.848,4.199,7.756,5.633c3.268,1.612,6.71,2.52,10.369,2.454 c3.388-0.061,6.585-0.933,9.625-2.413c2.448-1.192,4.668-2.727,6.753-4.468c0.724-0.604,1.448-1.214,2.21-1.769 c3.767-2.747,7.981-3.55,12.536-2.84c2.558,0.399,5.01,1.201,7.488,1.914c2.355,0.678,4.713,1.375,7.111,1.867 c2.544,0.522,5.123,0.509,7.676-0.147c2.614-0.671,4.531-2.18,5.556-4.674c0.595-1.447,0.998-2.974,1.466-4.472 c0.393-1.26,0.705-2.546,1.139-3.791c1.144-3.281,3.408-5.363,6.808-6.175c2.739-0.654,5.479-1.301,8.331-1.978 c0.091,0.39,0.214,0.678,0.218,0.967C158.601,113.455,158.495,117.295,157.755,121.076z"
      fill="#000"
    />
  </svg>
);

const PROVIDER_ICONS = {
  gmail: gmailIcon,
  outlook: outlookIcon,
  yahoo: yahooIcon,
  proton: protonIcon,
  icloud: icloudIcon,
  hey: defaultEmailIcon,
  aol: defaultEmailIcon,
  mailru: defaultEmailIcon,
  feedbin: feedbinIcon,
  'dev-mailpit': defaultEmailIcon,
};

const getProviderLabel = (provider) => {
  switch (provider) {
    case 'gmail':
      return t('Open Gmail');
    case 'outlook':
      return t('Open Outlook');
    case 'yahoo':
      return t('Open Yahoo Mail');
    case 'proton':
      return t('Open Proton Mail');
    case 'icloud':
      return t('Open iCloud Mail');
    case 'hey':
      return t('Open Hey');
    case 'aol':
      return t('Open AOL Mail');
    case 'mailru':
      return t('Open Mail.ru');
    case 'feedbin':
      return t('Open Feedbin');
    case 'dev-mailpit':
      return 'Open Mailpit (development only)';
    default:
      return t('Open email');
  }
};

/**
 * @param {object} props
 * @param {object} props.inboxLinks
 * @param {string} props.inboxLinks.android
 * @param {string} props.inboxLinks.desktop
 * @param {Provider} props.inboxLinks.provider
 */
function InboxLinkButton({ inboxLinks: { android, desktop, provider } }) {
  return (
    <a
      href={isAndroidChrome(navigator) ? android : desktop}
      target="_blank"
      rel="noreferrer noopener"
      className="gh-portal-btn gh-portal-btn-inbox-link"
    >
      {getOwn(PROVIDER_ICONS, provider) ?? defaultEmailIcon}
      <span>{getProviderLabel(provider)}</span>
    </a>
  );
}

export default InboxLinkButton;
